(function ($) {
    $(function () {
        // Global Variables
        var $window = $(window);

        // build tabs 
        var vTabs = $('ul.tabs.vertical'),
            tabBreak = 1024; //Breakpoint to turn into tabs

        if (vTabs.length) {
            var setContentHeight = function (con, tab) {
                var curItemHeight = con.outerHeight() + 15;
                tab.css('min-height', curItemHeight);
            };

            vTabs.each(function (idx, itm) {
                var idxClass = "tabs" + idx,
                    curTab = $(itm),
                    tabContent = curTab.find('li > .content');

                curTab.addClass(idxClass);

                var tabfunc = [
                    {
                        //function caled on mobile sizes
                        min: 0,
                        max: (tabBreak - 1),
                        enter: function () {
                            tabContent.hide();
                            curTab.find('> li > .title').on('click.vTabMobile', function () {
                                var $this = $(this);
                                $this.next('.content').slideToggle(200);
                                $this.parent('li').toggleClass(actClass);
                            });

                            curTab.children('li:first-child').find('>.title').trigger('click');
                            $window.trigger('resize');
                        },
                        exit: function () {
                            curTab.find('li > .title').off('click.vTabMobile');
                            curTab.find('li').removeClass(actClass);
                        }
                    },
                    {
                        //function caled on desktop sizes
                        min: tabBreak,
                        max: 99999,
                        enter: function () {
                            tabContent.hide();

                            curTab.children('li').each(function (idx2, listItem) {
                                var curItem = $(listItem),
                                    curItemContent = curItem.find('>.content');

                                curItem.children('.title').on('click.vTabFull', function () {
                                    if (!curItem.hasClass(actClass)) {
                                        $window.off('resize.' + idxClass);

                                        curTab.find('.tabs > li > .content').fadeOut(125).promise().done(function () {
                                            curTab.find('>li').removeClass(actClass).find('> .content').css('opacity', '0');
                                            curTab.find('>li').removeClass(actClass).find('> .content').css('display', 'none');
                                            curItemContent.show();
                                            setContentHeight(curItemContent, curTab);

                                            $window.on('resize.' + idxClass, function () {
                                                setContentHeight(curItemContent, curTab);
                                            });

                                            curItem.addClass(actClass);
                                            curItemContent.animate({
                                                opacity: 1
                                            }, 200, function () {
                                                $window.trigger('resize');
                                            });
                                        });
                                    }
                                });

                            });

                            curTab.children('li:first-child').find('> .title').trigger('click');
                            $window.trigger('resize');
                        },
                        exit: function () {
                            curTab.find('li').removeClass(actClass);
                            $window.off('resize.' + idxClass);
                            curTab.find('li > .title').off('click.vTabFull');
                            curTab.find('li > .content').removeAttr('style')
                            curTab.css('min-height', '');
                        }
                    }
                ];

                breakdance(tabfunc);

            });

            // accessibility support
            vTabs.find('li > .title').attr('tabindex', '0').attr('role', 'button').on('keyup', function (e) {
                var keyCode = e.which;
                if ((keyCode === 13) || (keyCode === 32)) {
                    $(this).click();
                }
            });
        }
    });
})($JQ);